export const environment = {
  production: false,
  authUrl: 'https://dev-auth.ace-alternatives.com/auth/realms/ace-test',
  clientId: 'gp-portal.app',
  baseUrl: 'https://investor-portal-mock-dev.ace-alternatives.com',
  tokenEndpoint:
    'https://dev-auth.ace-alternatives.com/auth/realms/ace-test/protocol/openid-connect/token',
  datahubApiUrl: 'https://dev.api.suite7.io/gp-portal/v1',
  datahubApiUrlV2: 'https://dev.api.suite7.io/gp-portal/v2',
  fundSandboxApiUrl: 'https://dev.fe.suite7.io/api',
  enablePortfolioCompanyManagementFlow: true,
  // Onboarding-only view (PoC): trims the sidebar and dashboard down to the
  // sections a GP still in onboarding actually uses -- Tasks (Management),
  // Onboarding, Investors, Documents, Team. Purely presentational; no routes
  // or components are removed, so flipping this to false restores the full portal.
  onboardingOnlyMode: true,
  teamApiUrl: 'https://api-dev.spike.suite7.io/api/v1',
  teamSocketUrl: 'https://api-dev.spike.suite7.io',
  webPushEnabled: false,
  navBaseUrl: 'https://api.dev.investornavigator.suite7.io',
  useRealAPI: false,
  pdfjsExpressViewerLicenseKey: 'H54vX6fcVEDr2EREk2ZS',
  pdfApryseViewerLicenseKey:
    'ACE Alternatives GmbH:OEM:Suite7::B+:AMS(20271219):82DCAE9307AAD4F33B313BC9C26039264E6F1FCF785A037E221BB404345037F151B6F5C7',
  layer: 'dev',
  lpDatahubApi: 'https://dev.api.suite7.io/lp-portal/v1',
  lpDatahubApiV2: 'https://dev.api.suite7.io/lp-portal/v2',
  moniteDropinUrl: 'https://api.sandbox.monite.com/v1',
  presignedDomainUrl: 'https://dev-assets.suite7.io/',
  enabledGPsForPonto:
    '71b0eec3-4979-47b5-ac0a-8a26640816d3,344c147e-a080-4dd7-9251-32eb69e48c81,c8dd24e7-8c40-454e-8a46-c345eacdec42',
  flagsmithAPI: 'https://flagsmith.ace-alternatives.com/api/v1/',
  flagsmithEnvironmentID: 'GFvxrpNSoxAR4nc2XWyLyJ',
};
